import { FC } from "react";
import { ADD_KEY, TRAILER_KEY, TableRowProps } from "../interface";

const TableRow: FC<TableRowProps> = props => {
  const { disabled, ...restProps } = props;
  const dataRowKey = props['data-row-key'];
  if (dataRowKey === undefined) return <tr {...props}></tr>;
  if (dataRowKey.includes(TRAILER_KEY)) return null;
  if (dataRowKey.includes(ADD_KEY) && disabled) return null;

  return (
    <tr {...restProps} />
  );
};

export default TableRow;
